/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seemly_Stout_Mink_ZapInputs */

const fr_seemly_stout_mink_zap = /** @type {(inputs: Seemly_Stout_Mink_ZapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste des programmes`)
};

/**

* @param {Seemly_Stout_Mink_ZapInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const seemly_stout_mink_zap = /** @type {((inputs?: Seemly_Stout_Mink_ZapInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seemly_Stout_Mink_ZapInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_seemly_stout_mink_zap(inputs)
});